import $ from 'jquery';


function startNotificationCounterTest() {

    alert("test");
}
 async function getSessionDetails() {
 

    $.ajax({
        url: "./Base/GetSessionSetting",
        type: "POST",
        dataType: "JSON",
        async: true,
        timeout: 5000,
        success: function (response) {

            const sesExpireMins = response.sesExpireMins;
            const sesNotExpMins = response.sesNotExpMins;
            window.localStorage.setItem('ExpireMinutes', sesExpireMins);
            window.localStorage.setItem('SessionExpireNotificationMinutes', sesNotExpMins);
            
       

        }
       
        .bind(this),
    });
    
}
export default (async () => {

    const dynamic = await getSessionDetails();
    function startNotificationCounterTest() {

        alert("test");
    }
 
})();